/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteStationForecast } from '../fn/forecast/delete-station-forecast';
import { DeleteStationForecast$Params } from '../fn/forecast/delete-station-forecast';
import { ForecastDeleteCountList } from '../models/forecast-delete-count-list';
import { ForecastImportReport } from '../models/forecast-import-report';
import { importStationForecast } from '../fn/forecast/import-station-forecast';
import { ImportStationForecast$Params } from '../fn/forecast/import-station-forecast';


/**
 * All about the forecast feature
 */
@Injectable({ providedIn: 'root' })
export class ForecastService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importStationForecast()` */
  static readonly ImportStationForecastPath = '/stations/{uid}/data/forecast/import';

  /**
   * Import forecast data for a station (prediction).
   *
   * Allow to import forecast data, via a CSV file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importStationForecast()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationForecast$Response(params: ImportStationForecast$Params, context?: HttpContext): Observable<StrictHttpResponse<ForecastImportReport>> {
    return importStationForecast(this.http, this.rootUrl, params, context);
  }

  /**
   * Import forecast data for a station (prediction).
   *
   * Allow to import forecast data, via a CSV file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importStationForecast$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationForecast(params: ImportStationForecast$Params, context?: HttpContext): Observable<ForecastImportReport> {
    return this.importStationForecast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ForecastImportReport>): ForecastImportReport => r.body)
    );
  }

  /** Path part for operation `deleteStationForecast()` */
  static readonly DeleteStationForecastPath = '/stations/{uid}/data/forecast';

  /**
   * Delete forecast data for a station (prediction).
   *
   * Allow to delete forecast data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStationForecast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteStationForecast$Response(params: DeleteStationForecast$Params, context?: HttpContext): Observable<StrictHttpResponse<ForecastDeleteCountList>> {
    return deleteStationForecast(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete forecast data for a station (prediction).
   *
   * Allow to delete forecast data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStationForecast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteStationForecast(params: DeleteStationForecast$Params, context?: HttpContext): Observable<ForecastDeleteCountList> {
    return this.deleteStationForecast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ForecastDeleteCountList>): ForecastDeleteCountList => r.body)
    );
  }

}
